module.exports = __webpack_public_path__ + "images/659f55625c47d22aa4315c448185a484.svg";